import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  // {
  //   path: 'sistema-globalipcert',
  //   loadChildren: () => import('./sistema-globalipcert/sistema-globalipcert.module').then(m => m.SistemaGlobalIPCertModule),
  // },
  // {
  //   path: 'certificado-ip',
  //   loadChildren: () => import('./certificado-IP/certificado-ip.module').then(m => m.CertificadoIPModule),
  // },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule),
  },
   {
    path: 'politica-privacidad',
    loadChildren: () => import('./politica-privacidad/politica-privacidad.module').then(m => m.PoliticaPrivacidadModule),
  },
  {
    path: 'terminos-condiciones',
    loadChildren: () => import('./terminos-condiciones/terminos-condiciones.module').then(m => m.TerminosCondicionesModule),
  },
  {
    path: 'politica-cookies',
    loadChildren: () => import('./politica-cookies/politica-cookies.module').then(m => m.PoliticaCookiesModule),
  },
  {
    path: 'verification',
    loadChildren: () => import('./verify-certificate/verify-certificate.module').then(m => m.VerifyCertificateModule),
  },
  // También en español para que pueda funcionar con el param opcional CSV
  {
    path: 'verificacion',
    loadChildren: () => import('./verify-certificate/verify-certificate.module').then(m => m.VerifyCertificateModule),
  },
  // Para cualquier otro path (dejar en último lugar)
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
